import ArchivedReportsModal from "./views/ArchivedReportsModal.vue";
import AutomatedReportEmailDeliveryTrackingsModal from "@/modules/emailDeliveryTrackings/views/AutomatedReportEmailDeliveryTrackingsModal.vue";

const EmptyLayout = () => import("@/components/layouts/EmptyLayout.vue");
const AutomatedReportEdit = () => import("./views/AutomatedReportEdit.vue");
const AutomatedReports = () => import("./views/AutomatedReports.vue");

export default [
  {
    path: "/automatedReports",
    name: "automatedReports",
    component: EmptyLayout,

    meta: {
      roles: ["ROLE_MANAGE_REPORTS"],
    },

    children: [
      {
        path: "",
        name: "automatedReports.list",
        component: AutomatedReports,

        meta: {
          roles: ["ROLE_MANAGE_REPORTS", "ROLE_EXTERNAL_USER"],
        },

        children: [
          {
            path: ":automatedReportId/archived",
            name: "automatedReports.archived",
            component: ArchivedReportsModal,
            props: true,
          },

          {
            path: ":automatedReportId/emailDeliveryTrackings",
            name: "automatedReports.emailDeliveryTrackings",
            component: AutomatedReportEmailDeliveryTrackingsModal,
            props: true,
          },
        ],
      },

      {
        path: "create/:automatedReportId?",
        name: "automatedReports.create",
        component: AutomatedReportEdit,

        props: true,

        meta: {
          roles: ["ROLE_MANAGE_REPORTS"],
        },
      },

      {
        path: ":automatedReportId/edit",
        name: "automatedReports.edit",
        component: AutomatedReportEdit,

        props: true,

        meta: {
          roles: ["ROLE_MANAGE_REPORTS"],
        },
      },
    ],
  },
];
